var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWomanHairstyle4E(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x34_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.9,211.4c-3.9-1.8-6.3-5.4-7.7-9.5c-12.2,3.1-15.9,20.1-3.5,27c-6.3,5.7-2.2,20,4.7,24.4c4.2,2.8,4.3,3.3,6.6,4.1 c2.7,1,5.1,0.8,7.6,0.3c5.9-1.2,8.4-8.1,8.8-11.3c0.5-4.1-2.3-10.3-6.7-11.1c6.9-5.8,6.4-17.5-0.8-22.8 C252.2,213.1,249,212.9,245.9,211.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.7,211.5c-6.6,6.3-7.6,18.9,4.9,22.8c-3.5,3.3-6.2,9.2-5.7,13.4c0.4,3.4,3.4,9.7,8.5,7.3c4.9,5.2,9.1,0.5,11.9-1.8 c9-8.5,18.6-30,6.3-36.3c9.5-6.2,3.4-17.9-10.4-20.7C470.6,202.3,465.4,211.2,456.7,211.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#362416",
    d: "M406.6,78.7c-2.3-0.7-4.9-1.2-7.8-1.8c-4.4-0.8-9.4-1.5-14.5-2.1c-1-0.1-1.9-0.2-2.9-0.3 c-9.5-0.8-19.6-1.1-29.1-0.7c-0.8,0-1.6,0.1-2.5,0.1c-5.9,0.3-11.6,1-16.6,1.9c-0.4,0.1-0.9,0.2-1.3,0.2c-1.2,0.2-2.4,0.5-3.7,0.7 c-10.3,2.1-20.7,5-29.5,10.4c-0.6,0.3-1.1,0.7-1.7,1.1c-3,2-5.9,4-8.2,6.5c39.2-21,88-22.4,129.3-7.7 C416,82.6,412.1,80.3,406.6,78.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M285.5,107.8c1.1,3.3,3.4,6.1,6.1,7.9c6.4-3.7,13.1-6.8,19.9-9.2c6.8-2.4,13.8-4.3,21-5.7c5.4-1,10.8-1.7,16.3-2 c5.5-0.4,11-0.4,16.5-0.1c15.1,0.8,29.8,4.2,43.3,10c0.7-0.2,1.3-0.5,2-0.8C373.6,86,322,82.3,285.5,107.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.3,38.2c-2.6-0.6-5.5-0.7-8.7-0.2c-0.2-0.3-0.3-0.6-0.5-0.9c-1.1,10.1-3.8,26.2-11.7,37.6c1,0.1,1.9,0.2,2.9,0.3 C393.2,68.1,402.3,51,402.3,38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.3,28.9c-3.1,1-6,2.5-8.7,4.8c-0.2,13.5-2.5,28.6-6.8,40.4c0.8,0,1.6-0.1,2.5-0.1C362.7,62.6,365.9,41,365.3,28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.3,76.9c1.2-0.3,2.5-0.5,3.7-0.7c-10-10.2-17.8-23.1-18.5-36.3c0,0.1,0,0.2,0,0.2c-2.8-0.1-5.6,0.1-8.3,0.7 C306.1,56.8,317.4,70.5,328.3,76.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M415,47.8c-2.7-4.5-6.9-8.3-12.7-9.6c0,12.8-9.1,29.9-18,36.7c5.2,0.5,10.1,1.2,14.5,2.1c2.9,0.5,5.5,1.1,7.8,1.8 c2.3-2,5.4-5.8,6.7-7.4C417.3,66.3,419.4,55.2,415,47.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.3,28.9c0.6,12.1-2.6,33.7-13,45c9.5-0.4,19.7-0.1,29.1,0.7c7.9-11.3,10.6-27.5,11.7-37.6 C388.3,29.7,376.2,25.5,365.3,28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.3,33.9c-8.3-12.4-41-8.8-42.9,6c0.8,13.2,8.6,26.2,18.5,36.3c0.4-0.1,0.9-0.2,1.3-0.2c5-1,10.6-1.6,16.6-1.9 c4.3-11.7,6.5-26.9,6.8-40.4C356.5,33.7,356.4,33.8,356.3,33.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.1,40.8c-4.1,0.8-7.9,2.5-11.2,5.2c-7.6,6.5-9.9,14.7-8.2,23.7c1.8,9.3,5.8,12.6,13,17.6c8.9-5.4,19.2-8.3,29.5-10.4 C317.4,70.5,306.1,56.8,305.1,40.8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ABFF7F",
    strokeWidth: 0.1112,
    d: "M444.1,194.4L444.1,194.4L444.1,194.4 C444.3,194.3,444.2,194.3,444.1,194.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M473.2,189.9c0-1.9,0-3.7-0.2-5.6l0,0C473.2,186.1,473.3,188,473.2,189.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M435.4,124.5c-1-0.8-2-1.5-3-2.3C433.4,123,434.4,123.7,435.4,124.5L435.4,124.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M429.3,120.1c0.9,0.6,1.8,1.3,2.7,1.9C431.2,121.3,430.3,120.7,429.3,120.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M473.2,189.9c0,0.1,0,0.3,0,0.4C473.2,190.1,473.2,190,473.2,189.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M428.8,119.7c0.2,0.1,0.4,0.3,0.6,0.4C429.2,119.9,429,119.8,428.8,119.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#352416",
    d: "M463.8,157.4c-7.1-12.7-16.8-23.8-28.4-32.8l0,0c-1-0.8-2-1.5-3-2.3c-0.1-0.1-0.2-0.2-0.3-0.2 c-0.9-0.6-1.8-1.3-2.7-1.9c-0.2-0.1-0.4-0.3-0.6-0.4c-6.3-4.3-13.1-7.9-20.2-11c-13.5-5.8-28.2-9.3-43.3-10 c-5.5-0.3-11-0.3-16.5,0.1s-10.9,1-16.3,2c-7.2,1.3-14.2,3.2-21,5.7c-6.8,2.4-13.5,5.6-19.9,9.2c-24.6,14.1-44.8,36.8-52.2,62.5 c-1.9,11.2-1.2,23.1,6.9,28.4c4.1,2.7,10,4.1,14.7,2.7c1.6-1.8,2.6-4,2.9-6.5c-4.6-20.7-5.8-45,10.9-61.4 c-14.6,20.9-8.9,46.9-6.5,60c8.5-0.5,12.8-9.7,13.3-18.6c-0.9-21.3,1.2-49.4,23.6-65.7c-17.2,18.3-22.1,41-19.5,63.4 c11.6,0.4,21.2-5.9,23.6-14.4l0.1,0.1c-2.6-18.7-1.4-42.7,15.1-56.9c-11.2,13.1-16.5,40.1-10.4,59.8c6.4,2,14.3-1.5,16.8-6.3 c0.1,0.1,0.2,0.2,0.3,0.3c-3-18.8,0.6-41.6,12.1-57c-5.3,12.4-13.1,29.7-8.6,58.8c4.4,1,10.3-0.9,13.2-3.4 c0.1,0.2,0.2,0.5,0.3,0.7c-1.8-19.5,1.7-40.6,14.5-56.1c-10,17.9-13.4,39.9-10,60.3c5.5,2.7,13.8,2.2,17.3-2.8 c6.4-18.4,7.1-39,3.1-57.6c8.1,17,5.7,40.9-0.1,59.5c4.1,3.3,10,4.2,15,2.6c7-18.8,6.8-43.1,2.8-57.2c8.2,15.7,6.9,36.6,2.1,54.3 c0,0,0,0,0.1-0.1c0.8,4.4,7.1,10.3,11.3,12c4.9,1.9,8.3,2,12.9,0.5c4.3-20.4-0.1-46.6-4.8-54.5c12,13.9,11.7,37.6,8.7,53 c0.1,0,0.1-0.1,0.2-0.1c0.3,10.7,9.5,19.3,17.8,19.4c8.4-20.2,2.9-45.9-3.6-61c14.1,20.3,14.1,45.7,8.3,61.6 c-1.8,10.8,7,15.2,11.7,15.7c0.6,0.1,1.2,0.1,1.8,0.1c8.6-0.3,13.7-9,15.3-15c0.1-0.3,0.2-0.6,0.2-0.9c0.3-1.9,0.4-3.9,0.5-5.8 c0-0.1,0-0.3,0-0.4c0-1.9-0.1-3.7-0.2-5.6l0,0c-1-9.6-4.6-18.5-9.3-27L463.8,157.4L463.8,157.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M410.5,107.9c5.4-2.5,10.4-7.7,9.7-13.6c-0.4-2.9-1-5.2-2-7.1c-41.4-14.7-90.1-13.4-129.3,7.7c-2.4,2.6-4,5.6-4,9.3 c0,1.2,0.2,2.4,0.6,3.6C322,82.3,373.6,86,410.5,107.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.3,190.8c-12.4-11.8-12.9-29.3-25-41.5c13.1,3.3,24.7,10.8,27.6,23.4c2.6-3.4-0.1-16.3-1.7-20.5 c-2.4-6.3-5.7-9.4-11.6-13.6c-7.4-5.3-16.4-7.4-25.1-9.4c-5.2-1.2-11.3-2.7-17.1-4.7c11.6,9,21.3,20.1,28.4,32.8h-0.1 c4.6,8.4,8.3,17.4,9.3,27c4.8,4.8,12.9,6.4,18.5,8.7C490.3,192.5,489.3,191.8,488.3,190.8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M432.1,122c0.1,0.1,0.2,0.2,0.3,0.2C432.3,122.2,432.2,122.1,432.1,122z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00C200",
    d: "M444.1,194.4L444.1,194.4L444.1,194.4C444.3,194.3,444.2,194.3,444.1,194.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M246.3,206.5c-8.1-5.3-8.8-17.2-6.9-28.4c-1.4,4.7-2.3,9.6-2.8,14.5c0,3.3,0.4,6.8,1.5,9.9 c1.4,4,3.8,7.5,7.7,9.3c3.1,1.4,6.3,1.7,9,1c2.4-0.6,4.5-1.9,6.1-3.7C256.2,210.6,250.3,209.2,246.3,206.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M263.9,202.7c0.1-0.6,0.1-1.2,0-1.8c1.6,0.4,3,0.6,4.4,0.5c-2.4-13.1-8.1-39.1,6.5-60 C258.1,157.8,259.3,182,263.9,202.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M435.5,134.6c6.5,15,12,40.8,3.6,61c1.8,0,3.5-0.3,5.1-1.1l0,0c0-0.1,0.1-0.1,0,0l0,0 c-0.2,0.6-0.3,1.2-0.4,1.8C449.7,180.2,449.6,154.9,435.5,134.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M417.2,177.7c1.2-0.4,2.5-0.9,3.9-1.5c3-15.5,3.3-39.1-8.7-53C417.1,131,421.5,157.2,417.2,177.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M281.7,182.8c0.1-0.9,0.1-1.8,0.1-2.6c1.3,0.2,2.7,0.3,4,0.4c-2.5-22.5,2.3-45.1,19.5-63.4 C282.9,133.4,280.8,161.5,281.7,182.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M331.1,163.1c0.9,0.9,2.1,1.5,3.5,1.8c-4.5-29,3.3-46.4,8.6-58.8C331.8,121.4,328.1,144.3,331.1,163.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M309.4,166.2c1.4,1.4,3,2.4,4.7,2.9c-6.1-19.7-0.8-46.7,10.4-59.8C308,123.5,306.7,147.5,309.4,166.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M369.9,163.6c0.2-0.3,0.4-0.5,0.5-0.8c0.7,1,1.6,1.9,2.5,2.7c5.8-18.5,8.2-42.4,0.1-59.5 C377.1,124.7,376.3,145.2,369.9,163.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M388,168.1c1.8-0.6,3.5-1.6,4.9-2.9c4.8-17.7,6.1-38.7-2.1-54.3C394.8,125,394.9,149.3,388,168.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M348.2,162.1c0.9,1.8,2.5,3.3,4.5,4.3c-3.4-20.4-0.1-42.4,10-60.3C349.9,121.5,346.4,142.6,348.2,162.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#785940",
    d: "M473,184.3L473,184.3c-0.4-3.9-1.2-7.7-2.4-11.4c1.8,8.1,2.1,16.7-0.7,23.7c-2.5,6.2-9.1,13.2-16.5,14.9 c0.8,0.2,1.5,0.4,2.1,0.4c0.6,0.1,1.2,0.1,1.8,0.1c8.6-0.3,13.7-9,15.3-15c0.1-0.3,0.2-0.6,0.2-0.9c0.3-1.9,0.4-3.9,0.5-5.8 c0-0.1,0-0.3,0-0.4C473.3,188,473.2,186.1,473,184.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M302,175.9c3.6-2.5,6.2-5.9,7.3-9.9l0.1,0.1c-2.5-17.4-1.5-39.3,11.9-53.8C305,128.7,297.7,145.9,302,175.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.2,209.7c1.7,0.1,3.3-0.1,4.8-0.5c1.6-1.8,2.6-4,2.9-6.5c-4.5-20.3-5.7-44.1,10.1-60.5 C254.5,156.2,248.5,183.5,256.2,209.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.6,108.1c-9.2,17.5-12.2,38.7-8.9,58.4c2.1,1.1,4.6,1.6,7.1,1.6C358.3,156.7,355,122.4,361.6,108.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.9,198.8c4.2-3.4,6.4-9.8,6.8-16c-0.9-20.9,1.2-48.3,22.3-64.7C278.3,135.2,268.8,170.6,274.9,198.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.8,168.1c2.7-1.3,4.9-3.2,6-5.3c0.1,0.1,0.2,0.2,0.3,0.3c-3-18.4,0.5-40.8,11.4-56.1 C329.2,118.7,319.3,146.4,324.8,168.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.1,137c12.5,19.9,12.3,43.9,6.7,59.2c-1.1,6.6,1.8,10.8,5.2,13.2C459.5,184.8,457.3,156.6,437.1,137z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.3,106.6c7.8,17,5.4,40.6-0.3,58.9c1.8,1.5,4.1,2.5,6.4,3C385.5,148,388.2,120.4,373.3,106.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.3,124.3c11.1,14.1,10.7,36.9,7.8,51.9c0.1,0,0.1-0.1,0.2-0.1c0.2,6.4,3.5,12,7.9,15.5 C434.7,170.5,430.9,137.5,413.3,124.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.6,112.6c7.2,15.4,5.9,35.5,1.3,52.6c0,0,0,0,0.1-0.1c0.7,3.9,5.6,8.9,9.7,11.2C406.6,154.2,406.9,128.9,391.6,112.6 z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanHairstyle4E);
export default __webpack_public_path__ + "static/media/woman_hairstyle_4e.9d091fe9bbf496fb8008ef6b188bc0ed.svg";
export { ForwardRef as ReactComponent };